import React from "react";
import { Link } from "react-router-dom";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-8 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                { /* <p>{props.data ? props.data.paragraph : "Loading"}</p> */}
                <Link
                  to="/register"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Schedule a Free Demo
                </Link>
                <Link
                  to="/contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Talk to Our Experts
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
